// 9fbef606107a605d69c0edbcd8029e5d 
import { STORES_INTL_ACTION_PATTERN } from '@tcp/core/src/constants/reducer.constants';

export default {
  STORES_INTERNATIONAL_GET_MODULEX: `${STORES_INTL_ACTION_PATTERN}STORES_INTERNATIONAL_GET_MODULEX`,
  STORES_INTERNATIONAL_SET_MODULEX: `${STORES_INTL_ACTION_PATTERN}STORES_INTERNATIONAL_SET_MODULEX`,
  STORES_INTERNATIONAL_CONDENSED_HEADER_OFFSET_SM: 60,
  STORES_INTERNATIONAL_CONDENSED_HEADER_OFFSET_LG: 70,
};
